import { render } from "./ContactosFormEnviadoView.vue?vue&type=template&id=fbb27748&scoped=true"
import script from "./ContactosFormEnviadoView.vue?vue&type=script&lang=js"
export * from "./ContactosFormEnviadoView.vue?vue&type=script&lang=js"

import "./ContactosFormEnviadoView.vue?vue&type=style&index=0&id=fbb27748&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbb27748"]])

export default __exports__